
import { Button } from "@/components/ui/button";
import { useOnboarding } from "@/hooks/useOnboarding";
import { ChevronDown, ChevronUp, Trash } from "lucide-react";
import { useState } from "react";

interface AdminBannerProps {
  onReset: () => void;
}

export function AdminBanner({ onReset }: AdminBannerProps) {
  const { getCurrentStep, getCurrentSubStep, state } = useOnboarding();
  const [showDetails, setShowDetails] = useState(false);
  const currentStep = getCurrentStep();
  const currentSubStep = getCurrentSubStep();
  
  return (
    <div className="bg-yellow-50 border-b border-yellow-100 px-4 py-2 mb-4 text-xs">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="font-medium">Admin Mode</span>
          <Button 
            variant="outline" 
            size="sm" 
            className="h-6 px-2 text-xs"
            onClick={() => setShowDetails(!showDetails)}
          >
            {showDetails ? (
              <ChevronUp className="h-3 w-3 mr-1" />
            ) : (
              <ChevronDown className="h-3 w-3 mr-1" />
            )}
            {showDetails ? "Hide Details" : "Show Details"}
          </Button>
        </div>
        <Button 
          variant="destructive" 
          size="sm"
          className="h-6 px-2 text-xs"
          onClick={onReset}
        >
          <Trash className="h-3 w-3 mr-1" />
          Reset Progress
        </Button>
      </div>
      
      {showDetails && (
        <div className="mt-2 space-y-2 bg-white p-2 rounded border border-yellow-100">
          <div>
            <span className="font-medium block">Current Step:</span>
            <code className="bg-slate-100 px-1 py-0.5 rounded text-xs">
              {currentStep?.id || 'none'} 
              {currentStep?.type === 'dayStep' && state.currentDayIndex !== undefined && 
                ` (Day ${state.currentDayIndex + 1})`}
            </code>
          </div>
          
          {currentSubStep && (
            <div>
              <span className="font-medium block">Current Sub-Step:</span>
              <code className="bg-slate-100 px-1 py-0.5 rounded text-xs">
                {currentSubStep.id}
              </code>
            </div>
          )}
          
          <div>
            <span className="font-medium block">File Path:</span>
            <code className="bg-slate-100 px-1 py-0.5 rounded text-xs break-all">
              {`src/data/steps/${currentStep?.id}.ts`}
            </code>
          </div>
        </div>
      )}
    </div>
  );
}
